import { mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import { Switch as cSwitch } from "@coreui/vue";
import { required, requiredIf, minLength } from "vuelidate/lib/validators";
import { orderService } from "../../services/OrderService";

export default {
    name: "editInsuranceReqGeneral",

    components: {
        Datepicker,
        Multiselect,
        cSwitch
    },

    props: {
        Id: {
            type: Number,
            default: 0
        }
    },

    data: () => {
        return {
            loading: true,

            //
            //
            currencies: ["EUR", "RON"],
            //
            customOptions: {},
            orderProperty: {
                StartDate: "",
                Period: 12,
                PaymentsNo: 1,
                SelectedInsurers: "",
                Remarks: ""
            },
            //
            paymentsNo: null,
            paymentOptions: [
                { Code: 1, Name: "1" },
                { Code: 2, Name: "2" },
                { Code: 4, Name: "4" }
            ],
            //
            insuranceCompanies: [],
            //
            orderSettings: {},
            //
            disabledDates: null,
           
        };
    },

    validations: {

    },

    computed: {
        ...mapGetters({
            // general
            orderTypeSettings: "general/orderTypeSettings",
            typeSettings: "general/typeSettings",

            // order
            order: "order/order",
            orderLoaded: "order/orderLoaded",
            orderEditable: "order/orderEditable",
            orderCustomOptions: "order/customOptions"
        }),
        //
        isValid() {
            return !this.$v.$anyError;
        },
      
    },

    created() {
        var orderType = 0;
        orderType = this.order.OrderTypeId;

        this.orderSettings = this.typeSettings(orderType);
        this.insuranceCompanies = this.orderSettings.JsonSettings.AvailableInsurers;

        // copy property options
        this.customOptions = JSON.parse(
            JSON.stringify(this.orderCustomOptions)
        );

        // copy editable fields from order
        this.orderProperty.StartDate = this.order.StartDate;
        this.orderProperty.Period = this.order.Period;
        this.orderProperty.PaymentsNo = this.order.PaymentsNo;
        this.orderProperty.SelectedInsurers = this.order.SelectedInsurers ? this.order.SelectedInsurers : [];
        this.orderProperty.Remarks = this.order.Remarks;
        this.orderProperty.OrderSubType = this.order.OrderSubType;

        this.paymentsNo = this.paymentOptions.find(
            item => item.Code == this.orderProperty.PaymentsNo
        );
       //

        var disabledToDate = new Date();
        //disabledToDate.setDate(disabledToDate.getDate() + 1);

        this.disabledDates = {
            to: disabledToDate
        };

        this.loading = false;

    },

    methods: {
        ...mapMutations({
            setCustomOptions: "order/setCustomOptions",
            setGeneralOrderFields: "order/setGeneralOrderFields"
        }),

        //
        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid;
        },

        //
        paymentsNo_changed(value) {
            this.paymentsNo = value;
            this.orderProperty.PaymentsNo = value.Code;
        },
        getPeriodTypeText: function () {
            switch (this.orderSettings.JsonSettings.PeriodType) {
                case 0:
                    return 'luni';
                case 1:
                    return 'ani';
                case 2:
                    return 'zile';
                default:
            }
        }
    },

    watch: {
        customOptions: {
            handler: function(val, oldVal) {
                this.setCustomOptions(val);
            },
            deep: true
        },

        orderProperty: {
            handler: function(val, oldVal) {
                if (!this.loading) {
                    this.setGeneralOrderFields(val);
                }
            },
            deep: true
        }
    }
};
